/****************************************************
 *
 * ReallySticky.ts v1.75
 *
 * @copyright Zooma 2017
 *
 * Simple barebones Sticky Element plugin for
 * maximal control. That's the dream anyway.
 *
 * HOW TO USE:
 *
 *  import { ReallySticky } from "path/to/ReallySticky"
 *
 *  const sticky   = new ReallySticky($('.sticky-element'), {
 *      containerSel    : '.MainWrapper',
 *      fixedTopNavSel  : '.TopNav',
 *      offset          : 32,
 *      breakpoint      : Config.breakpoints.tablet
 *  })
 *
 *  $(window).on('scroll', () => {
 *      sticky.update()
 *  })
 *
 *  $(window).on('resize', () => {
 *      sticky.update()
 *  })
 *
 */

const debug = false;

export class ReallySticky {
  public opts!: any;
  private $el!: JQuery;
  private $elParent!: JQuery;
  private $body!: JQuery;
  private $win!: JQuery<Window>;
  private $container!: JQuery | undefined;
  private $topNav!: JQuery | undefined;

  constructor($el: JQuery, options: any) {
    if ($el.length) {
      this.opts = Object.assign(
        {
          containerSel: "body",
          fixedTopNavSel: ".TopNav",
          elFixedClass: "is-reallyFixed",
          elStickedClass: "is-reallySticked",
          bodyFixedClass: "really-fixed",
          bodyStickedClass: "really-sticked",
          startStickyOffset: 0,
          offset: 32,
          breakpoint: 768,
          callback: false,
        },
        options
      );

      this.$el = $el;
      this.$elParent = $el.parent();
      this.$body = $("body");
      this.$win = $(window);
      this.$container =
        this.opts.containerSel !== "" && $(this.opts.containerSel) ? $(this.opts.containerSel) : undefined;
      this.$topNav =
        this.opts.fixedTopNavSel !== "" && $(this.opts.fixedTopNavSel) ? $(this.opts.fixedTopNavSel) : undefined;

      // Initiated width data
      this.$el.data("old-width", this.$elParent.width() as number);
      this.$el.data("old-win-width", this.$win.width() as number);

      if (this.$container && this.$container.length) {
        const wrapClass = "ReallySticky-wrapper";
        this.$el.wrap('<div class="' + wrapClass + '"/>');
        this.callback();

        if (debug) {
          console.log("ReallySticky: Initiated");
        }

        setTimeout(() => {
          this.update();
        }, 1000);
      } else {
        if (debug) {
          console.log("ReallySticky: $container is undefined");
        }
      }
    } else {
      if (debug) {
        console.log("ReallySticky: $el is undefined");
      }
    }
  }

  callback(...args: any[]) {
    if (typeof this.opts.callback === "function") {
      this.opts.callback.apply(this, args);
    }
  }

  restore() {
    this.$body.removeClass(this.opts.bodyFixedClass).removeClass(this.opts.bodyStickedClass);
    this.$el.removeAttr("style").removeClass(this.opts.elFixedClass).removeClass(this.opts.elStickedClass);
    this.$elParent.css("min-height", "");

    this.callback();
  }

  update() {
    if (
      (this.$win.width() as number) >= this.opts.breakpoint &&
      this.$elParent.length &&
      this.$el.length &&
      (this.$container ? this.$container.length : 0)
    ) {
      const parentOffset = this.$elParent.offset();
      const containerOffset = this.$container ? this.$container.offset() : undefined;
      const containerOffsetTop = containerOffset ? containerOffset.top : 0;
      const containerHeight = this.$container ? (this.$container.height() as number) : 0;

      const topNavHeight = this.$topNav && this.$topNav.length ? (this.$topNav.height() as number) : 0,
        scrollPos = (this.$win.scrollTop() as number) + topNavHeight + this.opts.offset,
        elHeight = this.$el.outerHeight() as number,
        /* eslint-disable */
        elPos = parentOffset ? parentOffset.top : 0, // Checking the parent's position, since it's relatively positioned
        elMaxPos =
          containerOffsetTop +
          containerHeight -
          elHeight -
          parseInt(this.$el.css("marginBottom").replace("px", ""), 10),
        widthChanged =
          this.$elParent.width() !== this.$el.data("old-width") || this.$win.width() !== this.$el.data("old-win-width"),
        viewportHeight = (this.$win.height() as number) - topNavHeight - this.opts.offset,
        itsAFit = elHeight <= viewportHeight;
      /* eslint-enable */

      if (!itsAFit) {
        if (this.$el.hasClass(this.opts.elFixedClass) || this.$el.hasClass(this.opts.elStickedClass)) {
          this.restore();
        }
        return false; // Bail early
      }

      if (this.$el.hasClass("Sidebar-inner")) {
        //console.log('itsafit?', itsAFit, 'top', this.$elParent.position().top, 'height', elHeight, 'container top', this.$container.offset().top, 'viewport height', viewportHeight)
        //console.log('cur width:', this.$elParent.width(), 'old- width:', this.$el.data('old-width'), 'widthChanged', widthChanged, this.$win.width(), this.$el.data('old-win-width'))
        //console.log('topNavHeight', topNavHeight, 'scrollPos', scrollPos, 'elPos', elPos, 'elMaxPos', elMaxPos, 'widthChanged', widthChanged)
        //console.log(this.$container.offset().top, this.$container.height(), elHeight, elMaxPos)
      }

      if ((scrollPos - this.opts.startStickyOffset) >= elPos && scrollPos < elMaxPos && (widthChanged || !this.$el.hasClass(this.opts.elFixedClass))) {
        // Stick it!
        this.$body.addClass(this.opts.bodyFixedClass).removeClass(this.opts.bodyStickedClass);
        this.$el
          .css("position", "fixed")
          .css("top", topNavHeight + this.opts.offset)
          .css("left", parentOffset ? parentOffset.left : 0)
          .css("width", this.$elParent.width() as number)
          .addClass(this.opts.elFixedClass)
          .removeClass(this.opts.elStickedClass)
          .data("old-width", this.$elParent ? (this.$elParent.width() as number) : 0);
      } else if (
        scrollPos >= elPos &&
        scrollPos >= elMaxPos &&
        (widthChanged || this.$el.hasClass(this.opts.elFixedClass))
      ) {
        // Stop it
        this.$body.removeClass(this.opts.bodyFixedClass).addClass(this.opts.bodyStickedClass);
        this.$el
          .css("position", "absolute")
          .css("top", elMaxPos - containerOffsetTop)
          .css("left", parentOffset ? parentOffset.left : 0)
          .css("width", this.$elParent ? (this.$elParent.width() as number) : 0)
          .removeClass(this.opts.elFixedClass)
          .addClass(this.opts.elStickedClass)
          .data("old-width", this.$elParent ? (this.$elParent.width() as number) : 0);
      } else if (scrollPos < elPos && this.$el.hasClass(this.opts.elFixedClass)) {
        // Restore it
        this.restore();
      }

      this.$el.data("old-win-width", this.$win.width() as number);
      this.callback();
    } else if (
      (this.$win.width() as number) < this.opts.breakpoint &&
      this.$el.length &&
      (this.$el.hasClass(this.opts.elFixedClass) || this.$el.hasClass(this.opts.elStickedClass))
    ) {
      // && (this.$body.hasClass(this.opts.bodyFixedClass) || this.$body.hasClass(this.opts.bodyStickedClass))) {
      // Below breakpoint width -- Restore everything
      this.restore();
    }
  }
}
